<template>
  <div>
    <Nav></Nav>
    <b-overlay :show="loadingReports" rounded="sm" spinner-type="grow">
      <b-container fluid>
        <b-row>
          <b-col>
            <h1>Propina Neta por Mesero</h1>
            <p class="text-muted">Propina recaudada en sus ventas, lo que aportó al pool y lo que recibió del reparto</p>
          </b-col>
        </b-row>

        <ReportSearchBar @search="searchRecv" @changed="filtersChanged"></ReportSearchBar>

        <!-- Filters changed message -->
        <b-card v-if="filtersHaveChanged" class="mt-5">
          <b-row>
            <b-col class="text-center py-5">
              <b-icon icon="search" font-scale="3" variant="primary"></b-icon>
              <h4 class="mt-3">Filtros modificados</h4>
              <p class="text-muted">Presiona el botón "Buscar" para actualizar el reporte</p>
            </b-col>
          </b-row>
        </b-card>

        <!-- Report content -->
        <b-card class="mt-5" v-else-if="reportTable.length > 0 && !filtersHaveChanged">
          <b-row class="mb-4">
            <b-col md="3" sm="6" class="mb-3">
              <b-card bg-variant="success" text-variant="white">
                <h4>${{ totalCollected.toFixed(2) }}</h4>
                <small>Propina Recaudada</small>
              </b-card>
            </b-col>
            <b-col md="3" sm="6" class="mb-3">
              <b-card bg-variant="info" text-variant="white">
                <h4>${{ totalContributed.toFixed(2) }}</h4>
                <small>Aportado al Pool</small>
              </b-card>
            </b-col>
            <b-col md="3" sm="6" class="mb-3">
              <b-card bg-variant="warning" text-variant="white">
                <h4>${{ totalReceived.toFixed(2) }}</h4>
                <small>Recibido del Reparto</small>
              </b-card>
            </b-col>
            <b-col md="3" sm="6" class="mb-3">
              <b-card bg-variant="primary" text-variant="white">
                <h4>${{ totalNet.toFixed(2) }}</h4>
                <small>Propina Neta</small>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-button variant="primary" @click="exportToExcel">
                <b-icon icon="download"></b-icon> Descargar Excel
              </b-button>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col>
              <b-table
                small
                striped
                hover
                :items="reportTable"
                :fields="tableFields"
                responsive
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
              >
                <template #cell(tips_collected)="data">${{ (data.value || 0).toFixed(2) }}</template>
                <template #cell(contributed)="data">${{ (data.value || 0).toFixed(2) }}</template>
                <template #cell(kept_from_own)="data">${{ (data.value || 0).toFixed(2) }}</template>
                <template #cell(received)="data">${{ (data.value || 0).toFixed(2) }}</template>
                <template #cell(net)="data">
                  <span class="font-weight-bold">${{ (data.value || 0).toFixed(2) }}</span>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>

        <!-- No data -->
        <b-card v-else-if="!loadingReports && !filtersHaveChanged" class="mt-5">
          <b-row>
            <b-col class="text-center py-5">
              <b-icon icon="info-circle" font-scale="3" variant="secondary"></b-icon>
              <h4 class="mt-3">No hay datos disponibles</h4>
              <p class="text-muted">Selecciona un rango de fechas y sucursales para ver el reporte</p>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import Nav from "../../components/Nav.vue";
import axios from "axios";
import moment from "moment";
import ReportSearchBar from "./searchBar/ReportSearchBar.vue";
import * as XLSX from "xlsx";

export default {
  name: "TipPerWaiter",
  components: { Nav, ReportSearchBar },
  data() {
    return {
      loadingReports: false,
      reportTable: [],
      filtersHaveChanged: false,
      dates: {
        initial_date: "",
        end_date: "",
        sucursales: [],
      },
      sortBy: "net",
      sortDesc: true,
      tableFields: [
        { key: "waiter_name", label: "Mesero", sortable: true, stickyColumn: true },
        { key: "tips_collected", label: "Recaudada", sortable: true },
        { key: "contributed", label: "Aportado", sortable: true },
        { key: "kept_from_own", label: "Retenido", sortable: true },
        { key: "received", label: "Recibido", sortable: true },
        { key: "net", label: "Neto", sortable: true },
      ],
    };
  },
  computed: {
    totalCollected() {
      return this.reportTable.reduce((s, i) => s + (i.tips_collected || 0), 0);
    },
    totalContributed() {
      return this.reportTable.reduce((s, i) => s + (i.contributed || 0), 0);
    },
    totalReceived() {
      return this.reportTable.reduce((s, i) => s + (i.received || 0), 0);
    },
    totalNet() {
      return this.reportTable.reduce((s, i) => s + (i.net || 0), 0);
    },
  },
  methods: {
    filtersChanged() {
      this.filtersHaveChanged = true;
    },
    searchRecv(p) {
      this.dates.initial_date = moment(p.initDate).format("YYYY-MM-DD") + " 00:00:00";
      this.dates.end_date = moment(p.endDate).format("YYYY-MM-DD") + " 23:59:59";
      this.dates.sucursales = p.sucursales;
      this.filtersHaveChanged = false;
      this.getReport();
    },
    getReport() {
      this.loadingReports = true;
      let that = this;
      this.reportTable = [];
      axios
        .post("/report/tips/net-by-waiter", this.dates)
        .then(function (response) {
          that.reportTable = response.data || [];
        })
        .catch(function (err) {
          that.makeToast("Error", err.response?.data || "Error al cargar el reporte", "danger");
        })
        .finally(() => {
          that.loadingReports = false;
        });
    },
    exportToExcel() {
      const workbook = XLSX.utils.book_new();
      const headers = this.tableFields.map((f) => f.label);
      const data = [headers];
      this.reportTable.forEach((item) => {
        data.push(this.tableFields.map((f) => (typeof item[f.key] === "number" ? item[f.key] : item[f.key] || "")));
      });
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      const moneyCols = ["tips_collected", "contributed", "kept_from_own", "received", "net"];
      for (let R = 1; R <= range.e.r; ++R) {
        this.tableFields.forEach((f, C) => {
          const addr = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[addr]) return;
          if (moneyCols.includes(f.key)) worksheet[addr].z = "$#,##0.00";
        });
      }
      XLSX.utils.book_append_sheet(workbook, worksheet, "Propina por Mesero");
      XLSX.writeFile(workbook, `propina_neta_mesero_${this.dates.initial_date}_a_${this.dates.end_date}.xlsx`);
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, { title, variant, autoHideDelay: 5000, appendToast: true });
    },
  },
};
</script>

<style scoped>
.b-table th {
  white-space: nowrap;
}
</style>
